export default "__VITE_ASSET__mK2Wy7ga__"